document.addEventListener('scroll', () => {
  const hero = document.getElementById('scrolled-hero');

  const progress = getScrollProgress(hero);

  const textLines = document.getElementsByClassName('text-line');
  const textBox = document.getElementById('text-box');

  if (hero && textLines && textBox) {
    if (progress == 1) {
      textLines[0].style.opacity = 0;
      textLines[1].style.opacity = 0;
      textLines[2].style.opacity = 0;
      textLines[3].style.opacity = 0;
      textLines[4].style.opacity = 0;

      textBox.style.display = 'none';
    } else {
      textLines[0].style.opacity = 1 - progress * 4;
      textLines[1].style.opacity = 1 - progress * 2;

      textLines[2].style.opacity = -0.4 + progress * 2;
      textLines[3].style.opacity = -0.6 + progress * 2;
      textLines[4].style.opacity = -0.9 + progress * 2;

      textBox.style.display = 'flex';
    }

    if (progress > 0.3) {
      textBox.style.top = '20%';
    } else {
      textBox.style.top = '40%';
    }
  }
});

function getScrollProgress(element) {
  if (!element) return 0;

  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  const blockTop = rect.top + window.scrollY;
  const blockBottom = rect.bottom + window.scrollY;

  const scrollY = window.scrollY;

  if (scrollY <= blockTop) return 0;
  if (scrollY >= blockBottom - windowHeight) return 1;

  return (scrollY - blockTop) / (blockBottom - windowHeight - blockTop);
}
